import { TokenType, useUrlTokenState } from '../components/auth/useUrlTokenState';
import { useUserMe } from '../contexts/remote-data/useUserMe';

export function useIsCarbonCropEmployee(): boolean {
  const { userMe } = useUserMe();
  const tags = userMe?.tags ?? [];
  const tokenState = useUrlTokenState();
  return tags.includes('carboncrop_employee') && tokenState.type === TokenType.no_token;
}
